import { render, staticRenderFns } from "./ReportBudget.vue?vue&type=template&id=97f6601e&scoped=true"
import script from "./ReportBudget.vue?vue&type=script&lang=js"
export * from "./ReportBudget.vue?vue&type=script&lang=js"
import style0 from "./ReportBudget.vue?vue&type=style&index=0&id=97f6601e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f6601e",
  null
  
)

export default component.exports